// 新媒体微详情页
import {reportActionToRedies, jumpToMapFun, clickMaskOrBtn, setbackData, getJumpWxAppUrl} from './utils';

import poiTag from './components/poiTag.vue';
// import foodPoiListCoupon from '../../components/foodPoiListCoupon.vue';
// import collectToast from '../../components/CollectToast/index.vue';
import pageTitle from '../../components/PageTitle/index.vue';
import DownLoadDialog from '../../components/DownLoadDialog/index.vue';
import bottomBtn from '../../components/bottomBtn.vue';
import pushNote from './components/pushNote/index.vue';
import poiDetail from './components/poiDetail.vue';
// import customVideo from '../../components/customVideo/index.vue';
import endDom from './components/endDom.vue';
import topPoiTitle from './components/topPoiTitle.vue';
import aiNote from '../../components/aiNote/index.vue';
import microNote from './components/microNote/index.vue';
import ctripCardList from './components/ctripCardList/index.vue';
import wxOpenButton from '../../components/wxOpenButton';
import contentEndBar from './components/contentEndBar.vue';
import animationImgCover from './components/animationImgCover.vue';
import animationDrag from './components/animationDrag.vue';
import loading from './components/loading.vue';
import operateActivity from './components/operateActivity/index.vue';
import banner from './components/banner.vue';
import middleDom from './components/middleDom.vue';
import timeTask from './components/timeTask/index.vue';
import confirmModal from './components/confirmModal.vue';
import adSpaceSdk from './components/adSpaceSdk.vue';

import {
    isWeiXin,
    isBaiduMap,
    isBaiduMapAuto,
    isAndroid,
    isIos,
    isIPhone,
    compareNAVersion,
    addPvNew,
    isNaComponent,
    hideBackBtn,
    parseJson
} from '../../utils';
import {initImgMonitor, leavePageReport, componentVerBury} from './bury';
import {setShareOption, initWxFn} from './initWxConfig.js';
import {goBackAnimation, setInitAnimation} from './initAnimation';
import {initSDK, executeSDK} from './initSDK';
import {usePushComponent, usePushTitle, pullUpFullScreen} from './pushConfig';
import {isScreenOptimization} from './abtestConfig.js';
import {openUrlByOpenApi, requestBdApi} from '@baidu/map-fe-utils';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {getLocation, getBosResizeUrl} from '../../views/main/utils';
import {sendLog} from '../../utils/log.js';

import {initParisInstance} from './components/operateActivity/initParisFactory.js';
import pageVisible from '@/pages/micro-detail/utils/pageVisibleEvent.js';
import {AdCore} from '@baidu/ad-comps';

export default {
    components: {
        // foodPoiListCoupon,
        // collectToast,
        pageTitle,
        DownLoadDialog,
        bottomBtn,
        'push-note': pushNote,
        poiDetail,
        // customVideo,
        'end-dom': endDom,
        'middle-dom': middleDom,
        topPoiTitle,
        aiNote,
        microNote,
        poiTag,
        ctripCardList,
        wxOpenButton,
        contentEndBar,
        animationImgCover,
        animationDrag,
        loading,
        operateActivity,
        banner,
        timeTask,
        confirmModal,
        adSpaceSdk
    },
    data() {
        return {
            //  上拉加载
            bottomLoadingFlag: false,
            // 上拉刷新失败
            bottomLoadingError: false,
            // 加载失败标志
            // 刷完笔记的文本提示
            finishedText: '已经到底啦！',
            commentData: [],
            commentLength: 0,
            unique_id: '', // todo
            tpFrom: '',
            likeLoading: false,
            titleText: '',
            isBaiduMap: isBaiduMap(),
            isBaiduMapAuto: isBaiduMapAuto(), // 车机地图
            requireFlag: new Date().getTime(),
            goMap: false,
            titleLeftStyle: {
                marginLeft: '20px'
            },
            showBottom: true,
            scrollDistance: 0,
            noteStyle: 'Micro',
            showPanel: false,
            commentNoteIndex: 0,
            hiddenBackBtn: false,
            playingVideoIndex: -1,
            vanListWrap: null,
            // 是否显示正文和评论
            showMainContent: false,
            // 页面滑动距离，只针对全民预警的push头部使用
            scrollValue: 0,
            middleIcon: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/push-quan-logo.png',
            hasCtripCard: false, // 携程指南豆腐块数据
            // 加载中GIF
            loadingIcon: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/feed/default/loading-icon.gif',
            // 到底icon
            finishedIcon: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/feed/default/finished-logo.png',
            jumpWxAppUrl: '',
            preloadObj: {},
            isWindowResize: false, // 窗口大小是否已经发生改变过
            animationParam: {
                width: 202,
                height: 265,
                left: 9,
                top: 608
            }, // ios透明动画参数
            isAnmiationBack: false, // 是否为ios动画返回
            visiblePageBorderRadius: false, // 页面是否需要圆角
            isFeedScrolled: false, // 页面是否已经滑动过
            isScreenOptimization,
            showConfirmModal: false, // 是否展示订阅提示弹窗
            firstPop: true, // 第一次弹出弹窗
            adCoreUtils: null, // 广告通用能力
            adInfo: {}, // 广告数据
            adAspectRatio: null, // 广告图片宽高比
            adType: '' // 广告类型 api/sdk
        };
    },
    provide() {
        return {
            rootDom: () => this.vanListWrap
        };
    },
    computed: {
        ...mapGetters('url', [
            'urlParams',
            'abtest',
            'source',
            'firstUnique_id',
            'uid',
            'dataType',
            'isHiddeNav',
            'showSingleNote',
            'wxShareUid',
            'isShare',
            'isPreloader',
            'isFeedAnimation',
            'isTaskOperate',
            'comVersion'
        ]),
        ...mapGetters('dataList', [
            'finishedFlag',
            'pn',
            'topPoiInfo',
            'dataList',
            'error',
            'isMapFeedFinished',
            'microPoiDetail',
            'commentFinishedFlag',
            'commenIndex',
            'requestTime'
        ]),
        ...mapGetters('firstScreen', [
            'JSInit_starttime'
        ]),
        ...mapGetters('login', [
            'isLogin',
            'showTempIframe'
        ]),
        ...mapGetters('preload', [
            'isPreload',
            'preloadImgCover'
        ]),
        ...mapGetters('subscribePush', [
            'guideTitle',
            'guideMessage',
            'guideCancelText',
            'guideConfirmText',
            'guideActionList',
            'isAccordGuide'
        ]),
        ...mapGetters([
            'is_dark',
            'phoneInfo',
            'cityId',
            'loc',
            'stbarHeight',
            'currentIndex',
            'downloadShowFlag',
            'firstLowImg',
            'showLoading'
        ]),
        searchBtnIcon() {
            // 实验组显示跳起始页入口
            return this.abtest.includes('107018');
        },

        showTopTitle() {
            const {from_map_area = '0'} = this.urlParams;
            return from_map_area === '1' && Object.keys(this.topPoiInfo).length > 0;
        },
        containerStyle() {
            const {showTopTitle, stbarHeight, isBaiduMap} = this;

            // 50是pageTitle的高度，78是topPoitTitle的高度
            let paddingHeight = 50;
            if (showTopTitle) {
                paddingHeight += 78;
            }
            let marginTop = 0;
            let containerHeight = '100vh';

            if (!this.isHiddeNav && this.isBaiduMap) {
                marginTop = stbarHeight + paddingHeight + 'px';
                // 如果展示导航栏，则顶部需要减去导航栏高度
                containerHeight = `calc(100vh - ${marginTop})`;
            }
            return {
                marginTop,
                height: containerHeight
            };
        },
        errorBarStyle() {
            const marginTop = (this.hiddenNav && this.firstError) ? this.stbarHeight + 'px' : '0px';
            return {
                marginTop
            };
        },
        firstError() {
            return (this.error || this.bottomLoadingFlag) && this.dataList.length <= 0;
        },
        pushSource() {
            return usePushTitle(this.source);
        },
        pageTitle() {
            // push来源title改成“百度地图”，其他场景显示“精选笔记”
            return this.pushSource ? '百度地图' : '精选攻略';
        },
        // 首篇是否是全名预警笔记
        firstIsForewarning() {
            const flag = this.dataList && this.dataList[0] && this.dataList[0].isForewarning || false;
            this.setFirstIsForewarning(flag);
            return flag;
        },
        // 首篇是全名预警笔记时，需要更改头部样式
        transBgColor() {
            return this.firstIsForewarning && this.scrollValue < 10 || false;
        },
        microContainerStyle() {
            return {
                backgroundPosition: `center top -${this.scrollValue}px`
            };
        },
        firstDataItem() {
            return this.dataList > 0 ? this.dataList[0] : {};
        },
        levelOne() {
            return this.firstDataItem.levelOne || '';
        },
        levelTwo() {
            return this.firstDataItem.levelTwo || '';
        },
        animationImgHeight() {
            const {width} = this.animationParam;
            const scale = width / window.innerWidth;
            return this.animationParam.height / scale;
        },
        showLoadingDv() {
            // 非单篇笔记默认显示loading
            if (isNaComponent() || ((this.abtest.includes('107537') && this.dataType !== 'poicomment'))) {
                return this.showLoading && !this.showSingleNote;
            }
            return false;
        },
        // 兼容ios18 字体加粗，使用500
        titleContentStyle() {
            if (isIPhone()) {
                return {
                    'font-weight': 500
                };
            }
            return {};
        }
    },
    created() {
        // store中的urlParams赋值
        this.fetchUrlParams();

        // 冲刺打卡活动提前初始化sdk实例
        if (this.isTaskOperate) {
            initParisInstance();
        }

        // android系统下，监听页面大小变化
        this.addAndroidSizeEvent();

        if (this.isPreloader) {
            //  如果preload 并且是动效打开，则隐藏导航栏和&设置背景透明
            if (this.isFeedAnimation) {
                document.body.style.background = 'transparent';
                document.body.style.opacity = '0';
                this.setHiddeNav(true);
            }

            // 监听预加载bdapi回调;
            this.initPreLoadData();
        }
        else {
            this.getCreatedFn();
        }

        // 团圆中国年红包活动sdk
        const {origin_from = '', taskInfo = '', ad = ''} = this.urlParams;
        if (taskInfo && origin_from === 'cny') {
            initSDK();
            executeSDK();
        }

        // 初始化广告通用能力
        if (ad === '1') {
            this.adCoreUtils = new AdCore({
                platformEnv: 'bdapi'
            });
        }
    },
    async mounted() {
        if (!this.isPreloader) {
            this.getMountedFn();
        }
    },
    methods: {
        ...mapActions({
            fetchUrlParams: 'url/fetchUrlParams',
            fetchPhoneInfo: 'fetchPhoneInfo',
            sendFirstScreenCostBury: 'firstScreen/sendFirstScreenCostBury',
            requireData: 'dataList/requireData',
            handleData: 'dataList/handleData',
            refreshBar: 'dataList/refreshBar',
            prePageHandle: 'preload/prePageHandle',
            updateReqParams: 'dataList/updateReqParams',
            handleSpaceCompress: 'dataList/handleSpaceCompress',
            updateArticleData: 'dataList/updateArticleData',
            goLogin: 'login/goLogin',
            getSubscribeInfo: 'subscribePush/getSubscribeInfo',
            sendSubscribeInfo: 'subscribePush/sendSubscribeInfo'
        }),
        ...mapMutations({
            setJSInitStartTime: 'firstScreen/setJSInitStartTime',
            setJsLoadCost: 'firstScreen/setJsLoadCost',
            setFirstIsForewarning: 'dataList/setFirstIsForewarning',
            setFinishedFlag: 'dataList/setFinishedFlag',
            setIsLogin: 'login/setIsLogin',
            setDownloadShowFlag: 'setDownloadShowFlag',
            setMicroPoiDetail: 'dataList/setMicroPoiDetail',
            setError: 'dataList/setError',
            setFirstLowImg: 'setFirstLowImg',
            setHasBase64: 'setHasBase64',
            setHiddeNav: 'url/setHiddeNav',
            setIsFeedAnimation: 'url/setIsFeedAnimation',
            setUrlParams: 'url/setUrlParams'
        }),
        // 跳起始页
        homePageClick() {
            addPvNew(['MCDfeed.mapMainNote.New.noteSearch.click'], {'note_Search_type': 1});
            window.location.href = 'baidumap://map/gopage?page=poisearchpage&popRoot=no';
        },
        getCreatedFn() {
            // 业务JS初始化逻辑开始时间
            this.setJSInitStartTime(Date.now());
            // 页面加载渲染耗时
            this.setJsLoadCost(this.JSInit_starttime - window.pageInit_starttime);
            // 页面预加载处理
            this.prePageHandle();
            this.showBury();
        },
        async getMountedFn(preloadPhoneInfo = {}) {
            // 针对push落地页，去掉组件中的返回按钮，使用系统自带返回按钮，调用bdapi去头协议
            if (this.pushSource && isAndroid()) {
                this.androidTitleHandle();
            }
            // 获取设备信息
            await this.fetchPhoneInfo(preloadPhoneInfo);

            // 获取广告数据
            this.getBannerRequest();

            // 获取笔记数据
            await this.getArticleData();

            // push返回拉起全屏
            if (pullUpFullScreen(this.source) && this.isBaiduMap) {
                setbackData(this.source);
            }
            this.initGlobalCommonListen();
            if (this.isBaiduMap) {
            // 后退回到页面，刷新数据
                requestBdApi('bdapi://robackRefresh');
            }
            window.noticeBack = async () => {
            // 跳转到poi列表底图，返回时只需要更新状态
            // goApp目前没有为true的情况
                if (this.goMap) {
                    this.goMap = false;
                    return;
                }
                // 更新当前一条笔记数据
                // tpl_type === 'feed'这个条件目前一直不成立
                if (!this.isLogin && this.dataList[this.currentIndex]?.tpl_type === 'feed') {
                    await this.refreshBar(this.currentIndex, this.unique_id);
                }
            };
            // 注册滑动埋点
            this.slidePv();

            this.handleSpaceCompress(true);

            this.vanListWrap = this.$refs.vanListWrap;

            // 图片加载耗时统计监听
            initImgMonitor();
            // 端外通过接口获取分享和poi端外展示需要的数据
            if (isWeiXin()) {
                initWxFn({wxShareUid: this.wxShareUid, dataList: this.dataList, pushSource: this.pushSource}).then(res => {
                    // 设置poi数据
                    this.setMicroPoiDetail(res.microPoiDetail);
                });
            }
            const {sv = ''} = this.phoneInfo || {};
            if (compareNAVersion(sv, '18.4.18') >= 0) {
                pageVisible.on('page-hide', () => {
                    const nowTime = Date.now();
                    addPvNew(['MCDfeed.feedtimeend.pt'], {
                        micro_startTime: window.pageInit_starttime,
                        micro_viewTime: nowTime - window.pageInit_starttime,
                        micro_endTime: nowTime
                    });
                    // 离开页面时上报最后一篇的浏览时长
                    leavePageReport();
                });
                // 页面消费时长统计
                const buryParams = {
                    source: this.source,
                    page: 'feed_imagetext_detail',
                    pagetype: 'feed_micro',
                    component_version: this.comVersion
                };
                this.$pageView.start(buryParams);
            }
            this.aiNotePoint();

            if (isNaComponent()) {
                // 组件包埋点
                componentVerBury();
            }
            this.setWxJumpToAppUrl();

            // 获取push订阅信息
            if (this.urlParams.push_recall_key) {
                this.getSubscribeInfo();
            }
        },
        // 预加载设置数据
        setPreLoadData() {

            const {preloadObj = {}} = this;
            const preloadData = parseJson(preloadObj);
            const {comParam = '', base64Img = '', nativeInfo = ''} = preloadData;
            const preloadInfoObj = parseJson(comParam);
            const preloadPhoneInfo = parseJson(nativeInfo);

            // 合并参数，优先使用preloadinfo中的参数
            const urlParamsObj = Object.assign({}, this.urlParams, preloadInfoObj);
            this.setUrlParams(urlParamsObj);

            const {animationParam = ''} = preloadInfoObj;

            if (animationParam) {
                this.handleFeedAnimatin(animationParam);
            }
            else {
                document.body.style.background = '#f2f4f5';
                document.body.style.opacity = '1';
                this.setIsFeedAnimation(false);
            }
            this.setHiddeNav(false);
            if (base64Img) {
                this.setFirstLowImg(base64Img);
                this.setHasBase64(true);
            }
            else {
                // 获取preloadinfo中的头图做缩略图
                if (preloadInfoObj?.preloadInfo) {
                    this.handlePreloadInfo(preloadInfoObj.preloadInfo);
                }
            }
            this.getCreatedFn();
            this.getMountedFn(preloadPhoneInfo);
        },

        /**
         * 处理动画加载参数
         *
         * @param {Object} preloadInfoObj - 预加载信息对象
         */
        handleFeedAnimatin(animationParam = '') {
            if (animationParam) {
                const animationParamStr = decodeURIComponent(animationParam);
                this.animationParam = parseJson(animationParamStr);
                this.setIsFeedAnimation(true);
                setInitAnimation({
                    isFeedAnimation: this.isFeedAnimation,
                    animationParam: this.animationParam
                });
            }
        },

        // bdapi回调，首页feed进入微详情后会触发bdapi回调，此时需要更新数据
        initPreLoadData() {
            window.getData = (preloadObj = {}) => {
                // 预加载情况，隐藏返回按钮
                hideBackBtn();
                // 添加预加载参数到console，方便排查
                console.info('预加载参数', preloadObj);
                // 预加载情况，端调用getData后重置页面加载开始时间，用于后续埋点使用
                window.pageInit_starttime = Date.now();
                this.preloadObj = preloadObj;
                this.setAndroidWindowSize();
                if (isIos() || (isAndroid() && this.isWindowResize)) {
                    this.setPreLoadData();
                }
            };
            requestBdApi('bdapi://businessData?callBack=getData');
        },
        // 从预加载参数中获取头图信息，并压缩成默认缩略图
        handlePreloadInfo(preloadInfo) {
            const info = parseJson(decodeURIComponent(preloadInfo));
            if (info?.cover?.src) {
                const imgSrc = info.cover.src;
                const {hostname = ''} = getLocation(imgSrc);
                const isBcebosSrc = hostname.endsWith('.cdn.bcebos.com');
                let pic = '';

                if (isBcebosSrc) {
                    pic = getBosResizeUrl({src: imgSrc, width: 200, height: 200, focus: true});
                }
                this.setFirstLowImg(pic);
            }
        },

        // 获取笔记数据
        async getArticleData(value = {isFromMap: false}) {
            this.setFinishedFlag(false);
            if (this.isShare === '1' || value.isFromMap) {
                this.updateArticleData(value);
            }

            if ((this.dataType !== 'poicomment' && !this.isPreload) && !value.isFromMap && this.firstUnique_id) {
                // 首篇笔记信息可以用轻量接口获取
                if (this.abtest.includes('107427')) {
                    // ab实验验证等待首篇笔记接口返回后再请求首屏数据的效果
                    await this.getFirstArticleData();
                }
                else {
                    this.getFirstArticleData();
                }
            }
            // 获取首屏数据
            await this.getFirstScreenData();
            if (this.isShare === '1' || value.isFromMap) {
                // 微信内打开app时，戳点后需要更新跳转链接
                this.setWxJumpToAppUrl();
            }
        },

        // 预加载图片获取图片宽高比
        preloadImage(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = function () {
                    const width = img.width;
                    const height = img.height;
                    const aspectRatio = width / height;
                    resolve(aspectRatio);
                };
                img.onerror = function () {
                    reject(new Error('Image failed to load'));
                };
                img.src = url;
            });
        },
        // push资讯页获取广告数据
        getBannerRequest() {
            if (!this.adCoreUtils) {
                return;
            }
            const info = {
                cardInfo: {
                    resource_id: 'push_page',
                    bid_type: 'sdk' // 使用SDK竞价
                }
            };
            this.adCoreUtils.getAdDataReqHandle(info).then(res => {
                const {code, data} = res;
                if (code === 0) {
                    const {ad_type = '', adList = []} = data || {};
                    this.adType = ad_type;
                    this.adInfo = adList?.[0] || {};
                    if (ad_type === 'sdk') {
                        return;
                    }
                    // api广告
                    if (!this.adInfo.img_url) {
                        return;
                    }
                    // 预加载图片获取图片宽高比
                    this.preloadImage(this.adInfo.img_url).then(ratio => {
                        this.adAspectRatio = ratio;
                    });
                }
            });
        },

        handleErrorUpdate(val) {
            this.setError(val);
        },
        // 获取首篇笔记数据
        async getFirstArticleData() {
            const data = await this.requireData({firstNode: true});
            this.handleData({data});
            if (this.showSingleNote) {
                // 显示单篇笔记时，设置请求结束标识
                this.setFinishedFlag(true);
            }
        },

        // 获取首屏数据
        async getFirstScreenData() {
            // 非评论转微详情的笔记，如果只显示首篇，则不需要再次请求
            if (this.showSingleNote) {
                return;
            }
            const data = await this.requireData({pn: this.pn});
            this.handleData({data, init: true});
        },

        // 使用push模版
        usePushNote(tp, source) {
            return usePushComponent(tp, source);
        },
        // 安卓版本低于19.8.0时，去头协议的返回按钮不生效，需要隐藏自定义组件中的返回按钮
        androidTitleHandle() {
            // push来源安卓端所有去头
            hideBackBtn();
            // 低版本去掉自定义返回按钮
            if (compareNAVersion(this.urlParams.sv, '19.8.0') < 0) {
                this.hiddenBackBtn = true;
            }
        },
        // 页面展现埋点
        showBury() {
            // 从na图区跳转进入时需要带上from_map_area参数
            const {from_map_area = '0'} = this.urlParams;
            addPvNew(['MCEDpoiugc.NewMedia.microDetail.PGshow'], {
                source: this.source,
                unique_id: this.firstUnique_id,
                note_style: 'Micro',
                type: 'image',
                levelOne: this.levelOne,
                levelTwo: this.levelTwo,
                from_map_area
            });
        },
        slidePv() {
            const containerWrap = this.$refs.vanListWrap;
            let scrollTop = 0;
            if (containerWrap) {
                containerWrap.addEventListener('scroll', e => {
                    scrollTop = e.target.scrollTop;
                    // 如果首篇是全民预警的push笔记
                    if (this.firstIsForewarning) {
                        this.scrollValue = scrollTop;
                    }
                    if (!this.isFeedScrolled) {
                        this.isFeedScrolled = true;
                    }
                });
                containerWrap.addEventListener('touchend', e => {
                    if (scrollTop === this.scrollDistance) {
                        return;
                    }
                    // 页面滑动埋点
                    addPvNew(['NewMedia.detailspage.slide.click'], {
                        source: this.source || 'feed',
                        type: 'image',
                        note_style: 'Micro',
                        cityId: this.cityId,
                        pn: this.pn,
                        warningnote: this.dataList[this.currentIndex].isForewarning ? 1 : 0,
                        authoritynote: this.dataList[this.currentIndex].isQwzh ? 1 : 0,
                        pushcategory: this.dataList[this.currentIndex].pushCategory,
                        levelOne: this.dataList[this.currentIndex].levelOne,
                        levelTwo: this.dataList[this.currentIndex].levelTwo,
                        user_behavior_sessionid: this.requestTime
                    });
                    this.scrollDistance = scrollTop;
                });
            }
        },
        // 上拉加载
        async loadData() {
            this.bottomLoadingFlag = true;
            const data = await this.requireData({pn: this.pn});
            this.handleData({data});
            this.bottomLoadingFlag = false;
        },
        goBackAnimationLayout() {
            this.setHiddeNav(true);
            this.navigatorBackPv();
            setTimeout(() => {
                this.isAnmiationBack = true;
            }, 0);
            document.body.style.background = 'transparent';
            const app = document.getElementById('app');
            app.style.background = 'transparent';
            goBackAnimation({
                isFeedAnimation: true,
                animationParam: this.animationParam
            });

        },
        handleDragActive(val) {
            this.visiblePageBorderRadius = val;
        },
        handleTitleCreated() {
            // 隐藏返回按钮
            hideBackBtn();
        },
        navigatorBack() {
            // 判断为第一次点返回 & 符合弹出条件，打开订阅提示弹窗
            if (this.firstPop && this.isAccordGuide) {
                this.firstPop = false;
                this.showConfirmModal = true;
                const {push_recall_key = ''} = this.urlParams;
                sendLog('MCDnhp.SubscriptionPopup.PGshow', {type: this.urlParams.push_recall_key});
                // 存储最新提醒订阅时间
                const lastSubscribe = JSON.parse(localStorage.getItem('lastSubscribe')) || {};
                localStorage.setItem('lastSubscribe', JSON.stringify({
                    ...lastSubscribe,
                    [push_recall_key]: Date.now()
                }));
                return;
            }
            if (this.isFeedAnimation) {
                this.goBackAnimationLayout();
                return;
            }
            if (this.isBaiduMapAuto) {
                location.href = 'bdapi://goback';
                return;
            }

            if (!this.isBaiduMap) {
                window.history.back(-1);
            }
            else {
                // 端内
                this.navigatorBackPv();
                location.href = 'bdapi://goback';
            }
        },
        // 更新分享内容
        async updateWxShare(shareObj) {
            setShareOption(shareObj, this.pushSource);
            let {
                unique_id = '',
                tpSource = '',
                subSource = '',
                log_id = '',
                index = ''
            } = shareObj || {};
            // 上报action
            reportActionToRedies({unique_id}, index, 'click_share', this.phoneInfo);
            addPvNew(['NewMedia.detailspage.shareBtn.click'], {
                type: 'image',
                note_style: 'Micro',
                loc: this.loc || '',
                abtest: this.abtest,
                log_id: log_id,
                cuid: this.phoneInfo.cuid,
                unique_id,
                source: this.source || 'feed',
                tp: tpSource,
                pmgc: subSource,
                warningnote: this.dataList[index].isForewarning ? '1' : '0',
                authoritynote: this.dataList[index].isQwzh ? '1' : '0',
                pushcategory: this.dataList[index].pushCategory
            });
        },
        // 评论事件监听
        initGlobalCommonListen() {
            const callBackName = 'updateCommonData';
            window[callBackName] = res => {
                if (res) {
                    const handleRes = typeof res === 'string' ? JSON.parse(res) : res;
                    const {status = '', type = ''} = handleRes || {};
                    if (type === 'addCommentSuccess') {
                        // todo 监听到评论成功，刷新当前评论数
                        // const unique_id = this.dataList[this.currentIndex]?.unique_id || '';
                        // this.refreshBar(this.currentIndex, unique_id, 'poicomment');
                    }
                    if (['replySuccess', 'addCommentSuccess'].includes(status)) {
                        this.setIsLogin(true);
                        const commentNum = this.dataList[this.currentIndex]?.comment_num || 0;
                        this.$set(this.dataList[this.currentIndex], 'comment_num', commentNum + 1);
                    }
                }
            };
            requestBdApi(`bdapi://subscribeGlobalMessage?callback=${callBackName}`);
        },
        jumpToMap() {
            this.setWxJumpToAppUrl('webapp.poi.poi_biji.h5');
            jumpToMapFun(() => {
                // 打开蒙层
                this.setDownloadShowFlag(true);
            }, this.jumpWxAppUrl);
        },
        // 点击蒙层或者按钮
        handleClick(obj) {
            clickMaskOrBtn(obj, () => {
                // 关闭蒙层
                this.setDownloadShowFlag(true);
            });
        },
        // 展开按钮处理
        contentOpen(currNoteData, index) {
            this.updateReqParams(currNoteData);
        },

        handleTitleContent() {
            // 把微详情内容滚动到面板顶部
            // this.$refs.contentStart.scrollIntoView({behavior: 'smooth', block: 'start'});
            this.$refs.vanListWrap.scrollTo({top: 0, behavior: 'smooth'});
        },

        jumpUrl(url) {
            addPvNew(['poidetail_explain_guide.click'], {
                type: 'picture'
            });
            openUrlByOpenApi(url);
        },
        // 携程卡片数据
        handleCardData(val) {
            this.hasCtripCard = val;
        },
        // 跳转到百度地图
        setWxJumpToAppUrl(appType = 'webapp.poi.poi_biji.weixin') {
            const unique_id = this.dataList?.[0]?.unique_id || '';
            const {wxShareUid = '', dataType = ''} =  this;
            this.jumpWxAppUrl = getJumpWxAppUrl({appType, wxShareUid, unique_id, dataType});
        },

        // ainote 埋点
        aiNotePoint() {
            this.$nextTick(() => {
                // ai导游埋点
                const aiNoteRef = this.$refs.aiNoteRef;
                aiNoteRef && aiNoteRef[0] && this.$io.observe(aiNoteRef[0].$el, () => {
                    addPvNew(['poidetail_explain_guide.show']);
                });
            });
        },

        // 安卓端预加载webview 初始化宽高为0, 重新设置window宽高,防止其他组件读取window宽高为0
        setAndroidWindowSize() {
            if (isAndroid()) {
                const preloadData = typeof preloadObj === 'string' ? parseJson(this.preloadObj) : this.preloadObj;
                const {webViewWidth = '', webViewHeight = ''} = preloadData;

                if (webViewWidth) {
                    window.innerWidth = webViewWidth;
                }
                if (webViewHeight) {
                    window.innerHeight = webViewHeight;
                }
            }
        },

        // 预加载情况，安卓端初始化webview宽度为0, 当webview布局完成后，窗口大小改变时，设置数据进行渲染
        addAndroidSizeEvent() {
            if (this.isPreloader && isAndroid()) {
                window.addEventListener('resize', () => {
                    if (!this.isWindowResize) {
                        this.setPreLoadData();
                    }
                    this.isWindowResize = true;
                });
            }
        },
        navigatorBackPv() {
            addPvNew(['PoiDPG.NewTravelPage.close.click'], {
                cityid: this.cityid,
                levelOne: this.levelOne,
                levelTwo: this.levelTwo
            });
        },
        handleModalCancel() {
            sendLog('MCDnhp.SubscriptionPopup.click', {
                type: this.urlParams.push_recall_key,
                Subscriptiontype: 2
            });
            // 关闭弹窗
            this.showConfirmModal = false;
            // 退出页面
            this.navigatorBack();
        },
        handleModalConfirm() {
            sendLog('MCDnhp.SubscriptionPopup.click', {
                type: this.urlParams.push_recall_key,
                Subscriptiontype: 1
            });
            // 确认订阅
            this.sendSubscribeInfo(1);
            setTimeout(() => {
                // 关闭弹窗
                this.showConfirmModal = false;
                // 退出页面
                this.navigatorBack();
            }, 200);
        },
        goBdLogin(value = '') {
            this.goLogin(value);
        }
    }
};
